export default __webpack_public_path__ + "static/media/thankyouimage.56ebcc9d.png";